import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { ViewerService } from '../../services/viewer/ViewerService';
import { useTimedFlag } from '../../utils/time';
import { Canvas } from '../Canvas';
import { FullscreenButton } from '../FullscreenButton';
import { EmbeddedViewHud } from '../huds/EmbeddedViewHud';
import { LoadingIndicator } from '../LoadingIndicator';
import { Stage } from '../Stage';
import { VideoDisplay } from '../VideoDisplay';
import { VideoOverlayDisplay } from '../VideoOverlayDisplay';
import { ViewerPreLive } from '../ViewerPreLive';
const GlobalStyle = createGlobalStyle `
    body {
        --Stage_PaddingTop: 0rem;
        --Stage_PaddingBottom: 0rem;
        --Stage_PaddingLeft: 0rem;
        --Stage_PaddingRight: 0rem;
    }
`;
export function EmbeddedView() {
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const isVideoStreaming = ViewerService.getOutput().useIsVideoStreaming();
    const [isHudVisible, showHud] = useTimedFlag(true, 5000);
    const [root, setRoot] = useState(null);
    const ready = ViewerService.getOutput().useReady();
    const viewerService = ViewerService.getNotificationInterface();
    const handleCanvasMount = useCallback((canvas) => {
        if (canvas) {
            viewerService.notifyCanvasMounted(canvas);
        }
    }, [viewerService]);
    return (_jsxs(_Fragment, { children: [_jsx(GlobalStyle, {}), isVideoStreaming && (_jsx(_Fragment, { children: _jsx("div", { "data-playing": true }) })), _jsxs(EmbeddedViewRoot, { ref: setRoot, onMouseDown: () => {
                    showHud();
                }, children: [_jsx(LoadingIndicator, { loading: !ready }), _jsxs(Stage, { children: [_jsx(VideoDisplay, { component: _jsx(Canvas, { onCanvasMount: handleCanvasMount }) }), !isVideoStreaming && (_jsx(ViewerPreLive, { roundedCorners: false, broadcastStreamId: activeBroadcast.streamId, broadcasterUserId: activeBroadcast.broadcasterUserId }))] }), _jsx(VideoOverlayDisplay, { children: _jsx(EmbeddedViewHud, { visible: isHudVisible, fullscreenButton: _jsx(FullscreenButton, { element: root }) }) })] })] }));
}
const EmbeddedViewRoot = styled.div `
    width: 100vw;
    height: 100vh;
    position: relative;
`;
